const keys = [{
    key: 'd624642affcb83df0c87471e41ca557df',
    name: `Заинтересованная сторона (ЗС)`
}, {
    key: 'e249a07138dd45d3f4ba27d90d6c2244d',
    name: 'Держатель сертификата (ДС)'
}, {
    key: 'b3940d35edbbb3d8204f1b820a87d8e12',
    name: 'Специалист оцифровки актов ЛПО'
}, {
    key: 'eeb43e3d0be1d6e8bb92aa704092f9df1',
    name: 'Аудитор'
}, {
    key: 'f23d9209a63265defaeda6693d6f4b94d',
    name: 'Наблюдатель'
}, {
    key: "a436a766765eabad209d971014b41999b",
    name: "Администратор оцифровки актов ЛПО",
}
]

export function getRoleName(key) {
    const id = keys.findIndex(val => val.key === key)
    if (id === -1)
        return 'Не определена'
    else
        return keys[id].name
}